const primeEnMessages = {
  'prime.title': 'Prime Users',
};

export default primeEnMessages;
